import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AccordionComponent } from './accordion.component';
import { AccordionPanelComponent } from './panel/accordion-panel.component';
import { AccordionPanelContentComponent } from './panel/content/accordion-panel-content.component';
import { AccordionPanelHeaderComponent } from './panel/header/accordion-panel-header.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    AccordionComponent,
    AccordionPanelHeaderComponent,
    AccordionPanelContentComponent,
    AccordionPanelComponent
  ],
  exports: [
    AccordionComponent,
    AccordionPanelHeaderComponent,
    AccordionPanelContentComponent,
    AccordionPanelComponent
  ]
})
export class AccordionModule {
}
